/* eslint-disable no-nested-ternary */
import CheckCircle from '@mui/icons-material/CheckCircle';
import LinkExternalIcon from '@mui/icons-material/Link';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/system/colorManipulator';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import clsx from 'clsx';
import ClipboardCopyIcon from 'components/Icons/ClipboardCopy';
import BgSvg from 'components/Img/tracking.jpg';
import TooltipCopied from 'components/TooltipCopied/TooltipCopied';
import formatDate from 'date-fns/format';
import get from 'lodash.get';
import React, { memo, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { find as findTracking } from 'redux/modules/tracking';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Grid,
  LinearProgress,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

let timeout: any = null;
const useStyles = makeStyles(
  (theme) => ({
    bgCont: {
      display: 'flex',
      color: '#fff',
      minHeight: 800,
      width: 'calc(100% + 2px)',
      position: 'relative',
      overflow: 'hidden',
    },
    bg: {
      display: 'flex',
      color: '#fff',
      backgroundImage: `url(${BgSvg})`,
      fallbacks: [
        {
          backgroundImage: 'linear-gradient(-30deg, #00004d 0%, #5333ed 49%, #2cd4d9 100%)',
        },
      ],
      minHeight: 800,
      width: 'calc(100% + 2px)',
      backgroundSize: 'cover',
      backgroundPosition: 'top center',
      position: 'absolute',
      transform: 'scale(1.3)',
      top: -120,
      left: 100,
    },
    bgOpacity: {
      backgroundColor: '#000',
      opacity: 0.3,
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
    bgContainerUp: {
      position: 'relative',
      display: 'flex',
      width: '100%',
      zIndex: 9999,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      margin: theme.spacing(2),
      marginTop: 120,
    },
    hideContainerUp: {
      zIndex: -1,
    },
    root: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      paddingLeft: theme.spacing(2),
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      paddingRight: theme.spacing(2),
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
      [theme.breakpoints.up('sm')]: {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
        paddingLeft: theme.spacing(3),
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
        paddingRight: theme.spacing(3),
      },
      maxWidth: 800,
      margin: '0 auto',
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
      backgroundColor: alpha(theme.palette.background.paper, 0.95),
      paddingTop: 16,
      paddingBottom: 16,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginTop: theme.spacing(3),
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginBottom: theme.spacing(3),
      textAlign: 'center',
      overflow: 'hidden',
    },
    containerLoading: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      paddingLeft: theme.spacing(2),
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      paddingRight: theme.spacing(2),
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
      [theme.breakpoints.up('sm')]: {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
        paddingLeft: theme.spacing(3),
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
        paddingRight: theme.spacing(3),
      },
      maxWidth: 800,
      margin: '0 auto',
      paddingTop: 16,
      paddingBottom: 16,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginTop: theme.spacing(3),
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginBottom: theme.spacing(3),
      textAlign: 'center',
      overflow: 'hidden',
    },
    rootNopadding: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      paddingLeft: theme.spacing(2),
      maxWidth: 800,
      margin: '0 auto',
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
      backgroundColor: alpha(theme.palette.background.paper, 0.95),
      paddingTop: 16,
      textAlign: 'center',
      overflow: 'hidden',
    },
    button: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      margin: theme.spacing(1),
    },
    progress: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      width: `calc(100% + calc(${theme.spacing(3).replace('px', '')} * 2))`,
      position: 'relative',
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      left: `-${theme.spacing(3)}`,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      top: `-${theme.spacing(2)}`,
    },
    shipIcon: {
      fontSize: 18,
    },
    trackingDate: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
      color: theme.palette.mode === 'light' ? 'rgb(53, 53, 53)' : 'rgb(255, 255, 255)',
      fontWeight: 'bold',
    },
    trackingTime: {
      color: 'rgb(149, 165, 166)',
    },
    timelineSeparator: {
      flex: '0 1 auto',
      width: 33,
    },
    timelineOppositeContent: {
      flex: '0 1 auto',
      width: 150,
    },
    timelineDot: {
      flex: '0 1 auto',
      alignSelf: 'center',
    },
    iconDelivered: {
      color: 'rgb(76,187,135)',
    },
    dotDelivered: {
      color: 'rgb(76,187,135)',
    },
    wrapperMap: {
      position: 'relative',
      overflow: 'hidden',
    },
    containerMap: {
      backgroundColor: '#fff',
      overflow: 'hidden',
      width: '100%',
      minHeight: 500,
      position: 'fixed',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
    },
    showMap: {
      zIndex: 999999,
    },
    buttonHideMap: {
      position: 'fixed',
      right: 20,
      top: 20,
      zIndex: 999999,
    },
    containerSearchFixed: {
      position: 'fixed',
      right: 20,
      top: 70,
      zIndex: 999999,
    },
    titlePop: {
      fontSize: 14,
      lineHeight: 'normal',
      display: 'block',
    },
    descriptionPop: {
      fontSize: 14,
      color: 'rgb(200,200,200)',
    },
    inputCenter: {
      textAlign: 'center',
    },
  }),
  { name: 'tracking' }
);

const Tracking = memo(
  () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const params = useParams();
    const [trackingNumber, setTrackingNumber] = useState(params.trackingNumber);
    const dispatch = useDispatch();

    const { t, locale } = useTranslation();

    const localeSplited = locale.split('-')[0];

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'tracking' does not exist on type 'Defaul... Remove this comment to see the full error message
    const loading = useSelector((state) => state.tracking.loadings.tracking);
    /** @type {import('../../../api/database/models').ParcelTrackingQueue} */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'tracking' does not exist on type 'Defaul... Remove this comment to see the full error message
    const trackingInfo = useSelector((state) => state.tracking.result['multi-tracking']);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'tracking' does not exist on type 'Defaul... Remove this comment to see the full error message
    const error = useSelector((state) => state.tracking.error);

    const onChangeTracking = (e: any) => {
      setTrackingNumber(e.target.value?.trim());
    };

    const getTracking = () => {
      if (!params.trackingNumber) {
        return;
      }
      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(() => {
        dispatch(
          findTracking('multi-tracking', {
            query: {
              trackingNumber: params.trackingNumber?.trim(),
            },
          })
        );
      }, 100);
    };

    useEffect(() => {
      getTracking();
    }, [params.trackingNumber]);

    const goToTracking = () => {
      if (trackingNumber) {
        navigate(`/tracking/${trackingNumber}`);
        window.location.reload();
      }
    };

    const totalRecords = typeof trackingInfo === 'object' && trackingInfo?.length;
    const loadingDatas = loading || (error ? false : !trackingNumber || !totalRecords);

    const clickEnterButton = (event: React.KeyboardEvent) => {
      if (event.key === 'Enter') {
        goToTracking();
      }
    };

    const generateLastEventHeader = (mainItem: any) => {
      const lastItem = mainItem.parcel_tracking_items[0];

      const ignoreEvent =
        lastItem?.tracking_code?.code === 'BPS-0000' ||
        lastItem?.tracking_code?.code === 'BPX-0000' ||
        lastItem?.tracking_code_vendor?.tracking_code?.code === 'BPS-0000' ||
        lastItem?.tracking_code_vendor?.tracking_code?.code === 'BPX-0000';

      if (ignoreEvent) {
        return null;
      }

      let localeData = get(
        lastItem,
        'tracking_code_vendor.tracking_code.tracking_code_locales',
        get(
          lastItem,
          'tracking_code_vendor.tracking_code_vendor_locales',
          get(lastItem, 'tracking_code.tracking_code_locales')
        )
      );

      if (localeSplited === 'pt') {
        localeData = localeData
          ? localeData.find((locale: any) => locale.locale.isoCode === 'br')
          : { description: 'No Description Assigned' };
      } else {
        localeData = localeData
          ? localeData.find((locale: any) => locale.locale.isoCode === localeSplited)
          : { description: 'No Description Assigned' };
      }

      // localeData = localeData
      //   ? localeData.find((locale: any) => locale.locale.isoCode === 'br')
      //   : { description: 'No Description Assigned' };

      const locationString = [
        lastItem.location,
        lastItem.state,
        lastItem.city,
        lastItem.country?.isoCode,
      ]
        .filter(Boolean)
        .join(', ');

      return (
        <Stack alignItems="flex-end" justifyContent="center">
          <Typography variant="h6" component="span">
            {localeData ? localeData.description : t('public.tracking.description')}
          </Typography>
          <Typography>{locationString}</Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography className={classes.trackingDate}>
              {formatDate(new Date(lastItem.timestamp), 'PP')}
            </Typography>
            <Typography className={classes.trackingTime}>
              {formatDate(new Date(lastItem.timestamp), 'p')}
            </Typography>
          </Stack>
        </Stack>
      );
    };

    return (
      <div className={classes.bgCont}>
        <Helmet>
          <link
            rel="stylesheet"
            href="https://unpkg.com/leaflet@1.5.1/dist/leaflet.css"
            integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
            crossOrigin=""
          />
        </Helmet>

        <div className={classes.bg} />
        <div key="map" id="map" className={clsx(classes.containerMap)} />
        <div className={classes.bgOpacity} />
        <div className={clsx(classes.bgContainerUp)}>
          <Helmet title={`Tracking #${params && params.trackingNumber}`} />
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={12} sm={11} md={9}>
              <Paper elevation={4} className={classes.root}>
                {loading && <LinearProgress className={classes.progress} />}
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography variant="h4" component="h1" paragraph>
                      {t('public.tracking.bpx')}
                    </Typography>
                    <Typography component="p">
                      {t('public.tracking.subtitle.description')}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={3} justifyContent="center">
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          InputProps={{
                            classes: {
                              input: classes.inputCenter,
                            },
                          }}
                          placeholder={t('public.tracking.search.placeholder')}
                          onChange={onChangeTracking}
                          defaultValue={trackingNumber}
                          variant="standard"
                          onKeyPress={clickEnterButton}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button color="primary" onClick={goToTracking} variant="outlined">
                          {t('public.tracking.btn.search')}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>

              <Paper elevation={4} className={classes.rootNopadding}>
                {loading && <LinearProgress className={classes.progress} />}
                <Grid container spacing={3} justifyContent="space-between">
                  {trackingInfo?.map((mainItem: any, index1: number) => (
                    <>
                      {mainItem.label ? (
                        <Accordion
                          sx={{ width: '100%' }}
                          defaultExpanded={trackingInfo?.length === 1}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${index1}a-content`}
                            id={`panel${index1}a-content`}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                              spacing={4}
                              width="100%"
                              sx={{ marginRight: 4 }}
                            >
                              <Typography>
                                {`${mainItem.label.trackingNumber} - ${mainItem.label.externalTrackingNumber}`}
                              </Typography>
                              {!loading &&
                                !!trackingNumber &&
                                !!mainItem.parcel_tracking_items &&
                                generateLastEventHeader(mainItem)}
                            </Stack>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Grid item xs={12}>
                              <Stack justifyContent="space-between" direction="row">
                                <TooltipCopied
                                  PopperProps={{
                                    style: { zIndex: 99999 },
                                  }}
                                >
                                  <Button
                                    size="small"
                                    className="copy"
                                    variant="outlined"
                                    aria-label={mainItem.label.trackingNumber}
                                    endIcon={<ClipboardCopyIcon />}
                                  >
                                    {mainItem.label.trackingNumber}
                                  </Button>
                                </TooltipCopied>
                                <TooltipCopied
                                  PopperProps={{
                                    style: { zIndex: 99999 },
                                  }}
                                >
                                  <Button
                                    size="small"
                                    className="copy"
                                    variant="outlined"
                                    aria-label={mainItem.label.externalTrackingNumber}
                                    endIcon={<ClipboardCopyIcon />}
                                  >
                                    {mainItem.label.externalTrackingNumber}
                                  </Button>
                                </TooltipCopied>
                              </Stack>
                            </Grid>
                            <Grid item xs={12} sm={loadingDatas || error ? 12 : 12}>
                              {loadingDatas && (
                                <div className={classes.containerLoading}>
                                  {(loading || totalRecords === false) && (
                                    <Typography variant="subtitle1" gutterBottom>
                                      {t('public.tracking.loading')}
                                    </Typography>
                                  )}
                                  {(loading || totalRecords === false) && <CircularProgress />}
                                </div>
                              )}
                              {!loadingDatas && !totalRecords && (
                                <>
                                  <Typography align="center" color="error">
                                    {error ? error.message : t('public.tracking.notfound')}
                                  </Typography>
                                  <Typography align="center" variant="caption" gutterBottom>
                                    {t('public.tracking.contact.message')}
                                  </Typography>
                                  <Typography component="div">
                                    <Button
                                      component="a"
                                      href="mailto:traffic@bringer.com"
                                      variant="outlined"
                                    >
                                      {t('public.tracking.contact.btn.text')}
                                    </Button>
                                  </Typography>
                                </>
                              )}
                              {!loading && !!trackingNumber && !!mainItem.parcel_tracking_items && (
                                <Timeline>
                                  {!loading &&
                                    !!trackingNumber &&
                                    mainItem.parcel_tracking_items.map((item: any, index: any) => {
                                      const info = item;

                                      const ignoreEvent =
                                        info?.tracking_code?.code === 'BPS-0000' ||
                                        info?.tracking_code?.code === 'BPX-0000' ||
                                        info?.tracking_code_vendor?.tracking_code?.code ===
                                          'BPS-0000' ||
                                        info?.tracking_code_vendor?.tracking_code?.code ===
                                          'BPX-0000';

                                      if (ignoreEvent) {
                                        return null;
                                      }
                                      const vendorCode =
                                        info.tracking_code_vendor && info.tracking_code_vendor.code;

                                      let localeData = get(
                                        info,
                                        'tracking_code_vendor.tracking_code.tracking_code_locales',
                                        get(
                                          info,
                                          'tracking_code_vendor.tracking_code_vendor_locales',
                                          get(info, 'tracking_code.tracking_code_locales')
                                        )
                                      );

                                      if (localeSplited === 'pt') {
                                        localeData = localeData
                                          ? localeData.find(
                                              (locale: any) => locale.locale.isoCode === 'br'
                                            )
                                          : { description: 'No Description Assigned' };
                                      } else {
                                        localeData = localeData
                                          ? localeData.find(
                                              (locale: any) =>
                                                locale.locale.isoCode === localeSplited
                                            )
                                          : { description: 'No Description Assigned' };
                                      }

                                      // localeData = localeData
                                      //   ? localeData.find(
                                      //       (locale: any) => locale.locale.isoCode === 'br'
                                      //     )
                                      //   : { description: 'No Description Assigned' };
                                      const isDelivered =
                                        info?.tracking_code_vendor?.tracking_code?.code ===
                                          'BPS-1601' ||
                                        info?.tracking_code_vendor?.tracking_code?.code ===
                                          'BPX-1601';

                                      const isFirst = index === 0;

                                      const isLast =
                                        index === mainItem.parcel_tracking_items.length - 1;
                                      const timeLineConnectorAttributes =
                                        isDelivered && isFirst
                                          ? { sx: { bgcolor: 'secondary.main' } }
                                          : {};

                                      const locationString = [
                                        info.location,
                                        info.state,
                                        info.city,
                                        info.country?.isoCode,
                                      ]
                                        .filter(Boolean)
                                        .join(', ');

                                      return (
                                        <TimelineItem>
                                          <TimelineOppositeContent
                                            sx={{ m: 'auto 0' }}
                                            align="right"
                                            variant="body2"
                                            color="text.secondary"
                                            className={classes.timelineOppositeContent}
                                          >
                                            <Typography
                                              className={classes.trackingDate}
                                              align="inherit"
                                            >
                                              {formatDate(new Date(info.timestamp), 'PP')}
                                            </Typography>
                                            <Typography
                                              className={classes.trackingTime}
                                              align="inherit"
                                              display="block"
                                              variant="caption"
                                            >
                                              {formatDate(new Date(info.timestamp), 'p')}
                                            </Typography>
                                          </TimelineOppositeContent>
                                          <TimelineSeparator className={classes.timelineSeparator}>
                                            {isDelivered && isFirst ? (
                                              <TimelineDot
                                                className={classes.timelineDot}
                                                color="success"
                                                variant="outlined"
                                              >
                                                <CheckCircle className={classes.iconDelivered} />
                                              </TimelineDot>
                                            ) : isLast ? (
                                              <TimelineDot className={classes.timelineDot}>
                                                <LocalShippingIcon />
                                              </TimelineDot>
                                            ) : (
                                              <TimelineDot className={classes.timelineDot} />
                                            )}
                                            {!isLast && (
                                              <TimelineConnector {...timeLineConnectorAttributes} />
                                            )}
                                          </TimelineSeparator>
                                          <TimelineContent>
                                            <Typography variant="h6" component="span">
                                              {localeData
                                                ? localeData.description
                                                : t('public.tracking.description')}
                                            </Typography>
                                            <Typography display="block" variant="overline">
                                              {locationString}
                                            </Typography>
                                            {vendorCode === 'PAR-17' && (
                                              <Typography component="div" align="inherit">
                                                <Button
                                                  startIcon={<LinkExternalIcon />}
                                                  component="a"
                                                  // eslint-disable-next-line max-len
                                                  href="https://apps.correios.com.br/cas/login?service=https%3A%2F%2Fapps.correios.com.br%2Fportalimportador%2Fpages%2FpesquisarRemessaImportador%2FpesquisarRemessaImportador.jsf"
                                                  variant="outlined"
                                                  target="_blank"
                                                >
                                                  {t('public.tracking.go.pay.taxes')}
                                                </Button>
                                              </Typography>
                                            )}
                                            {info.additionalInformation && (
                                              <Typography
                                                display="block"
                                                variant="overline"
                                                style={{ fontSize: '8px' }}
                                              >
                                                {info.additionalInformation}
                                              </Typography>
                                            )}
                                          </TimelineContent>
                                        </TimelineItem>
                                      );
                                    })}
                                </Timeline>
                              )}
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      ) : (
                        <Accordion
                          sx={{ width: '100%' }}
                          defaultExpanded={trackingInfo?.length === 1}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${index1}a-content`}
                            id={`panel${index1}a-content`}
                          >
                            <Typography color="red">{`${mainItem.uid}`}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Grid item xs={12} sm={loadingDatas || error ? 12 : 12}>
                              {loadingDatas && (
                                <div className={classes.containerLoading}>
                                  {(loading || totalRecords === false) && (
                                    <Typography variant="subtitle1" gutterBottom>
                                      {t('public.tracking.loading')}
                                    </Typography>
                                  )}
                                  {(loading || totalRecords === false) && <CircularProgress />}
                                </div>
                              )}
                              <>
                                <Typography align="center" color="error">
                                  {mainItem.status}
                                </Typography>
                                <Typography align="center" variant="caption" gutterBottom>
                                  {t('public.tracking.contact.message')}
                                </Typography>
                                <Typography component="div">
                                  <Button
                                    component="a"
                                    href="mailto:traffic@bringer.com"
                                    variant="outlined"
                                  >
                                    {t('public.tracking.contact.btn.text')}
                                  </Button>
                                </Typography>
                              </>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      )}
                      <input type="hidden" />
                    </>
                  ))}
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  },
  () => true
);

export default Tracking;
